<div class="menu" [ngClass]="{ 'bordered': withBorderBottom, 'mobile-menu': isMobile }">
  <!-- Desktop: Swiper carousel -->
  <ng-container *ngIf="!isMobile">
    <swiper-container #swiperRef appSwiperElement [config]="config" [init]="false">
      <swiper-slide class="slide" *ngFor="let menuItem of menuItems">
        <div
          class="menu-item"
          [ngClass]="{'active-item' : activeMenuItem?.name === menuItem.name,'disabled': menuItem.disabled || menuItem.loading, 'errored': menuItem.error}"
          (click)="menuItem.disabled ? undefined : handleMenuItemClick(menuItem)">
          <ng-container *ngIf="!menuItem.loading; else loader">
            <nb-icon *ngIf="menuItem.icon" icon="{{ menuItem.icon }}" pack="icomoon" class="icon-menu"></nb-icon>
            <i *ngIf="menuItem.faIcon" class="fa icon-menu" [ngClass]="menuItem.faIcon"></i>
            <h3>
              <ng-container *ngIf="menuItem.translation"> {{ 'view_translations.' + menuItem.translation | translate }} </ng-container>
              <ng-container *ngIf="menuItem.text"> {{ menuItem.text }} </ng-container>
            </h3>
            <div class="counter" *ngIf="menuItem.count">
              <span>{{ menuItem.count }}</span>
            </div>
          </ng-container>
        </div>
      </swiper-slide>
    </swiper-container>
  </ng-container>

  <!-- Mobile: Horizontal scroll -->
  <ng-container *ngIf="isMobile">
    <div class="mobile-scroll-container">
      <div
        class="menu-item"
        *ngFor="let menuItem of menuItems"
        [ngClass]="{'active-item' : activeMenuItem?.name === menuItem.name,'disabled': menuItem.disabled || menuItem.loading, 'errored': menuItem.error}"
        (click)="menuItem.disabled ? undefined : handleMenuItemClick(menuItem)">
        <ng-container *ngIf="!menuItem.loading; else loader">
          <nb-icon *ngIf="menuItem.icon" icon="{{ menuItem.icon }}" pack="icomoon" class="icon-menu"></nb-icon>
          <i *ngIf="menuItem.faIcon" class="fa icon-menu" [ngClass]="menuItem.faIcon"></i>
          <h3>
            <ng-container *ngIf="menuItem.translation"> {{ 'view_translations.' + menuItem.translation | translate }} </ng-container>
            <ng-container *ngIf="menuItem.text"> {{ menuItem.text }} </ng-container>
          </h3>
          <div class="counter" *ngIf="menuItem.count">
            <span>{{ menuItem.count }}</span>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #loader>
  <div [style.minWidth.px]="150">
    <app-loader-for-list></app-loader-for-list>
  </div>
</ng-template>
